(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["hk-first-featured-products"] && !window.DesignMode) return;
  try {
    
  var ffpY = jQuery(".s-ffp .sfp:first-child").outerHeight()
    var ffpX = jQuery(".s-ffp .sfp:first-child").outerWidth()
    var diameter = Math.sqrt((ffpY * ffpY) + (ffpX * ffpX));

  var bildschirmX = jQuery(window).outerWidth();
  var aktuelleKreisGroesse = "350px";
  
  function ffpWerteMessen() {
    ffpY = jQuery(".s-ffp .sfp:first-child").outerHeight()
    ffpX = jQuery(".s-ffp .sfp:first-child").outerWidth()
    diameter = Math.sqrt((ffpY * ffpY) + (ffpX * ffpX));
  }

  ffpWerteMessen()

  $(window).resize(function() {
    bildschirmX = jQuery(window).outerWidth();
    bildschirmCheck(bildschirmX);
    ffpWerteMessen()
  });

  function hoverGeschichte() {
    $(".sfp").hover(
      function() {
        $(this).children(".sfp__circle").css("width", diameter + "px")
        console.log("rein")
      },
      function() {
        //$(this).children
        $(this).children(".sfp__circle").css("width", aktuelleKreisGroesse)
      }
    );
  }

  function bildschirmCheck(bildschirmX) {
    if(bildschirmX >= 876) {
      console.log("drüber");
      hoverGeschichte(bildschirmX)
    } else {
      console.log("drunter");
      $(".sfp").unbind('mouseenter mouseleave')
    }
  }
  bildschirmCheck(bildschirmX);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["start-filter-section"] && !window.DesignMode) return;
  try {
    
  var startTime = '16:20:00';
  var endTime = '16:23:00';
  
  currentDate = new Date()   
  
  startDate = new Date(currentDate.getTime());
  startDate.setHours(startTime.split(":")[0]);
  startDate.setMinutes(startTime.split(":")[1]);
  startDate.setSeconds(startTime.split(":")[2]);
  
  endDate = new Date(currentDate.getTime());
  endDate.setHours(endTime.split(":")[0]);
  endDate.setMinutes(endTime.split(":")[1]);
  endDate.setSeconds(endTime.split(":")[2]);
  
  
  valid = startDate < currentDate && endDate > currentDate

  if(valid) {
    $(".infinite-text").removeClass("hidden");
  }
  

  } catch(e) { console.error(e); }
})();
      })();
